export const luxury = [
  {
    id: 1,
    name: "Mercedes GLE E300",
    image: "/images/gallery/luxury/gle-e300.jpg",

    gallery: [
      "/images/gallery/luxury/gle-e300.jpg",
      "/images/gallery/luxury/gle-e300-interior.jpg",
      "/images/gallery/luxury/gle-e300-tyre.jpg",
    
    ],

    body: "Luxury SUV",
    seats: "4 + 1",
    doors: "5",
    engine: "1991 cc / Hybrid",
    transmission: "Automatic",
    fuel: "Petrol / Hybrid",
    ac: "AC"
  },

  {
    id: 2,
    name: "Mercedes E–220",
    image: "/images/gallery/luxury/e220.jpg",

    gallery: [
      "/images/gallery/luxury/e220.jpg",
      "/images/gallery/luxury/e220-interior.jpg",
      "/images/gallery/luxury/e220-side.jpg",
    
    ],

    body: "Luxury Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "1950 cc Diesel",
    transmission: "Automatic",
    fuel: "Diesel",
    ac: "AC"
  },

  {
    id: 3,
    name: "Mercedes E–250",
    image: "/images/gallery/luxury/e250.jpg",

    gallery: [
      "/images/gallery/luxury/e250.jpg",
      "/images/gallery/luxury/e25-interior.jpg",
      "/images/gallery/luxury/e250-rear.jpg",

    ],

    body: "Luxury Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "1991 cc Petrol",
    transmission: "Automatic",
    fuel: "Petrol",
    ac: "AC"
  },

  {
    id: 4,
    name: "Jaguar XF",
    image: "/images/gallery/luxury/jaguar-xf.jpg",

    gallery: [
      "/images/gallery/luxury/jaguar-xf.jpg",
      "/images/gallery/luxury/jaguar-xf-interior.jpg",
      "/images/gallery/luxury/jaguar-xf-side.jpg"
    ],

    body: "Luxury Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "1997 cc",
    transmission: "Automatic",
    fuel: "Petrol / Diesel",
    ac: "AC"
  },

  {
    id: 5,
    name: "BMW 5 Series",
    image: "/images/gallery/luxury/bmw-5series.jpg",

    gallery: [
      "/images/gallery/luxury/bmw-5series.jpg",
      "/images/gallery/luxury/bmw-5series-interior.jpg",
      "/images/gallery/luxury/bmw-5series-back.jpg",

    ],

    body: "Luxury Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "1998 cc",
    transmission: "Automatic",
    fuel: "Petrol / Diesel",
    ac: "AC"
  },

  {
    id: 6,
    name: "BMW 3 Series",
    image: "/images/gallery/luxury/bmw-3series.jpg",

    gallery: [
      "/images/gallery/luxury/bmw-3series.jpg",
      "/images/gallery/luxury/bmw-3interior.jpg",
      "/images/gallery/luxury/bmw-3side.jpg",
    
    ],

    body: "Luxury Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "1998 cc",
    transmission: "Automatic",
    fuel: "Petrol / Diesel",
    ac: "AC"
  },

  {
    id: 7,
    name: "Discovery Sport (Pvt)",
    image: "/images/gallery/luxury/discovery-sport.jpg",

    gallery: [
      "/images/gallery/luxury/discovery-sport.jpg",
      "/images/gallery/luxury/discovery-sport-interior.jpg",
      "/images/gallery/luxury/discovery-sport-rear.jpg",

    ],

    body: "Luxury SUV",
    seats: "6 + 1",
    doors: "5",
    engine: "1999 cc",
    transmission: "Automatic",
    fuel: "Diesel / Petrol",
    ac: "AC"
  }
];
